import { QueryClientProvider } from '@tanstack/react-query';
import { ChatApiVersionGuard, TooltipProvider } from '@odo/shared-ui';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import { ErrorBoundary } from './components/ErrorBoundary';
import { ToastContainer } from './components/Toast';
import { UpdateBanner } from './components/UpdateBanner';
import { PatientActionsProvider } from './contexts/PatientActionsContext';
import { RecentActionsProvider } from './contexts/RecentActionsContext';
import { Forbidden } from './pages/errors/Forbidden';
import { PracticesProvider } from './providers/practices/PracticesProvider';
import { PatientMetadataProvider } from './providers/PatientMetadataProvider';
import { queryClient } from './providers/queryClient';
import { ToastProvider } from './providers/ToastProvider';
import { UserProvider } from './providers/UserProvider';
import OnboardingPage from './pages/Onboarding/OnboardingPage';
import { AccountRoute } from './Routes/AccountRoute';
import { BillingRoutes } from './Routes/billing';
import { HomeRoutes } from './Routes/home';
import { LoginRoute } from './Routes/loginRoute';
import { MessagesRoutes } from './Routes/messages';
import { PatientActionRoutes } from './Routes/patientActions';
import { PatientCreationRoutes } from './Routes/patientCreation';
import { ResourcesRoutes } from './Routes/resources';

function invalidateAllQueries(): void {
    void queryClient.invalidateQueries();
}

function App() {
    return (
        <ErrorBoundary>
            <QueryClientProvider client={queryClient}>
                <TooltipProvider>
                    <UserProvider>
                        <PracticesProvider>
                            <ToastProvider>
                                <Router>
                                    <RecentActionsProvider>
                                        <PatientMetadataProvider>
                                            <PatientActionsProvider>
                                                <Routes>
                                                    <Route
                                                        path="/account"
                                                        element={<AccountRoute />}
                                                    />
                                                    <Route path="/login" element={<LoginRoute />} />
                                                    <Route
                                                        path="/forbidden"
                                                        element={<Forbidden />}
                                                    />
                                                    <Route
                                                        path="/conversations/*"
                                                        element={<MessagesRoutes />}
                                                    />
                                                    <Route
                                                        path="/billing/*"
                                                        element={<BillingRoutes />}
                                                    />
                                                    <Route
                                                        path="/resources/*"
                                                        element={<ResourcesRoutes />}
                                                    />
                                                    <Route
                                                        path="/patient/creation/*"
                                                        element={<PatientCreationRoutes />}
                                                    />
                                                    <Route
                                                        path="/patient/*"
                                                        element={<PatientActionRoutes />}
                                                    />
                                                    <Route
                                                        path="/onboarding"
                                                        element={<OnboardingPage />}
                                                    />
                                                    <Route path="/*" element={<HomeRoutes />} />
                                                </Routes>
                                                <ToastContainer />
                                                <UpdateBanner />
                                                <ChatApiVersionGuard
                                                    onSwitch={invalidateAllQueries}
                                                />
                                            </PatientActionsProvider>
                                        </PatientMetadataProvider>
                                    </RecentActionsProvider>
                                </Router>
                            </ToastProvider>
                        </PracticesProvider>
                    </UserProvider>
                </TooltipProvider>
            </QueryClientProvider>
        </ErrorBoundary>
    );
}

export default App;
